// extracted by mini-css-extract-plugin
export default {"mainLogin":"Login_mainLogin__dbH10","loginBtn":"Login_loginBtn__Yy-sX"};